import React from "react";
import EndingCards from "./sub-components/EndingCard";
import { EndingCardsSkeleton } from "../screening/sub-components/skeleton";

const Ebay = ({ totalFreightCount, totalGroundCount, isShelvingLoading }) => {
  return (
    <div style={{ marginTop: 38 }}>
      {isShelvingLoading ? (
        <EndingCardsSkeleton />
      ) : (
        <EndingCards
          totalFreightCount={totalFreightCount}
          totalGroundCount={totalGroundCount}
        />
      )}
    </div>
  );
};

export default Ebay;
// checked
